mutation DeleteEmptyProductLinesFromConsole(
    $ids: [ID!]!
) {
    deleteEmptyProductLines(
        ids: $ids
    ) {
        id
    }
}
